import React, { memo } from 'react'

const AccArrowUp = () => (
  <svg width="20" height="8" viewBox="0 0 27 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M26 13.9727L13.5 0.972655L1 13.9727" stroke="black"/>
  </svg>
)

export default memo (AccArrowUp);